<script setup lang="ts">
import { Link } from "@inertiajs/vue3"

import { ICON } from "@/lib/icons"
import { batchPath } from "@/routes"

defineProps<{
  batchId: string
  suggestions: Array<{
    groupId: string
    groupNumber: number
    name: string
  }>
}>()

defineEmits<{
  done: []
}>()
</script>

<template>
  <div
    data-testid="batch-ready"
    role="status"
    aria-live="polite"
    class="flex flex-1 flex-col items-center justify-center gap-6 bg-black p-6 text-white"
  >
    <div class="bg-success/20 flex size-16 items-center justify-center rounded-full">
      <UIcon :name="ICON.check" class="text-success size-8" />
    </div>
    <div class="text-center">
      <h1 class="text-2xl font-semibold">Batch ready</h1>
      <p class="mt-2 text-sm text-white/60">Your photos are ready to review.</p>
    </div>

    <div v-if="suggestions.length" class="w-full max-w-sm rounded-2xl bg-white/10 p-4">
      <p class="mb-3 text-xs font-semibold tracking-wide text-white/50 uppercase">AI suggestions</p>
      <ul class="space-y-2">
        <li
          v-for="suggestion in suggestions"
          :key="suggestion.groupId"
          class="flex items-center gap-2 text-sm"
        >
          <span class="text-white/50">Item {{ suggestion.groupNumber }}</span>
          <span class="font-medium">{{ suggestion.name }}</span>
        </li>
      </ul>
    </div>

    <div class="flex w-full max-w-sm flex-col gap-2">
      <Link
        :href="batchPath(batchId)"
        class="bg-primary text-inverted flex min-h-12 items-center justify-center rounded-md px-4 text-base font-semibold"
      >
        Open batch
      </Link>
      <UButton size="xl" block color="neutral" variant="outline" @click="$emit('done')">
        Done
      </UButton>
    </div>
  </div>
</template>
